import { EmployeeCompensation } from 'app/containers/EmployeeCompensation'
import * as React from 'react'

const VALID_STATE_CODES = {
  AK: true,
  AL: true,
  AR: true,
  AZ: true,
  CA: true,
  CO: true,
  CT: true,
  DC: true,
  DE: true,
  FL: true,
  GA: true,
  HI: true,
  IA: true,
  ID: true,
  IL: true,
  IN: true,
  KS: true,
  KY: true,
  LA: true,
  MA: true,
  MD: true,
  ME: true,
  MI: true,
  MN: true,
  MO: true,
  MS: true,
  MT: true,
  NC: true,
  ND: true,
  NE: true,
  NH: true,
  NJ: true,
  NM: true,
  NV: true,
  NY: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  RI: true,
  SC: true,
  SD: true,
  TN: true,
  TX: true,
  UT: true,
  VA: true,
  VT: true,
  WA: true,
  WI: true,
  WV: true,
  WY: true,
}

const TRUSTEE_COMPENSATION_CONFIG = {
  apiUrl: 'https://9jtty2utj2.execute-api.us-east-1.amazonaws.com/trustee-compensation',
  pageTitle: 'Trustee Compensation Table',
  tableSubtitle: 'Highest Paid Trustees',
  tableHeading: 'Highest Paid Trustees',
  loadingLabel: 'Loading trustee compensation...',
  emptyLabel: 'No trustees matched the current filters.',
  errorMessage: 'We were unable to load trustee compensation data right now.',
  filterStateOption: (option) => {
    const optionCode = option.code || option.value

    return optionCode === null || optionCode === '' || VALID_STATE_CODES[String(optionCode)] === true
  },
}

const TrusteeCompensation = () => (
  <EmployeeCompensation config={TRUSTEE_COMPENSATION_CONFIG} />
)

export {
  TrusteeCompensation
}



// WEBPACK FOOTER //
// ./src/app/containers/TrusteeCompensation/index.tsx